// extracted by mini-css-extract-plugin
module.exports = {"BundleHighlights":"BundlesHighlights_BundleHighlights__XUias"};